import React from "react";
import './switch-toggle.scss';
import {useSelector} from "react-redux";
import users from "../../users";
import {cn} from "../../../utils/utils";

type Props = {
    value: boolean;
    setValue: (value: boolean) => void;
    disabled?: boolean;
    size?: 'small' | 'medium' | 'large';
    onLabel?: React.ReactNode;
    offLabel?: React.ReactNode;
}

const SwitchToggle = ({
                          value,
                          setValue,
                          disabled = false,
                          size = 'medium',
                          onLabel,
                          offLabel,
                      }: Props) => {

    const darkMode = useSelector(users.selectors.isDarkMode);

    const toggle = () => {
        if (!disabled) setValue(!value);
    }

    const onKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (disabled) return;
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggle();
        }
    }

    return (
        <div
            role="switch"
            aria-checked={value}
            aria-disabled={disabled}
            tabIndex={disabled ? -1 : 0}
            className={cn('switch-toggle', `switch-toggle--${size}`,
                value ? 'switch-toggle--on' : 'switch-toggle--off',
                {'switch-toggle--disabled': disabled},
                {'switch-toggle--dark': darkMode}
            )}
            onClick={toggle}
            onKeyDown={onKeyDown}
        >
            {offLabel && <span className="switch-toggle__label switch-toggle__label--off">{offLabel}</span>}

            <div className="switch-toggle__track">
                <div className="switch-toggle__circle"/>
            </div>

            {onLabel && <span className="switch-toggle__label switch-toggle__label--on">{onLabel}</span>}
        </div>
    )
}

export default SwitchToggle;
